import { observer } from "mobx-react";
import React from "react";

export type ImageLayout = 'wide' | 'landscape' | 'square' | 'portrait';

type ImageLayoutPickerProps = {
  layout: ImageLayout;
  onSelect: (layout: ImageLayout) => void;
};

export function getLayoutIcon(layout: ImageLayout): React.ReactNode {
  switch (layout) {
    case 'landscape':
      return (<svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="7" width="20" height="10" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>);
    case 'square':
      return (<svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>);
    case 'portrait':
      return (<svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>);
    default:
      return null;
  }
}

@observer
class ImageLayoutPicker extends React.Component<ImageLayoutPickerProps> {
  render() {
    const { layout, onSelect } = this.props;

    const aspectRatios: { ratio: string, name: string }[] = [
      /*{ 
        ratio: '3:1', 
        name: 'Wide'
      },*/ { 
        ratio: '16:9', 
        name: 'Landscape'
      }, { 
        ratio: '1:1', 
        name: 'Square'
      },
      { 
        ratio: '9:16', 
        name: 'Portrait'
      }
    ];

    return (
      <div className="control-group">
        <label>Layout:</label>
        <div className="layout-selector">
          {aspectRatios.map((ratio) => (
            <button
              key={ratio.name}
              className={'layout-btn' + (layout === ratio.name.toLowerCase() ? ' active' : '')}
              onClick={() => onSelect(ratio.name.toLowerCase() as ImageLayout)}
              title={`${ratio.name} (${ratio.ratio})`}
            >
              <span className="layout-icon">
                {getLayoutIcon(ratio.name.toLowerCase() as ImageLayout)}
              </span>
            </button>
          ))}
        </div>
      </div>
    );
  }
  
  
}

export default ImageLayoutPicker;